module.exports = __webpack_public_path__ + "img/s8on.efe63ca3.svg";